import { ReportView, useBrandex } from "@brandex/dashboard";
import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle } from "@brandex/ui";
import { ArrowLeft, Share2 } from "lucide-react";

/**
 * A client's monthly report as the doctor sees it (F-14). Platform numbers
 * come from the client's connected social accounts (Social media tab).
 */
export function ClientReportPage({ orgId }: { orgId: string }) {
  const { nav } = useBrandex();
  return (
    <div className="grid gap-6">
      <div className="print:hidden">
        <Button size="sm" variant="ghost" onClick={() => nav.navigate("/clients")}>
          <ArrowLeft className="h-4 w-4" aria-hidden />
          Clients
        </Button>
      </div>
      <ReportView orgId={orgId} heading="Client report" />
      <Card className="print:hidden">
        <CardHeader>
          <CardTitle>Platform numbers</CardTitle>
          <CardDescription>
            The report shows the numbers of the client's connected social accounts, as of their last sync, labelled with their source.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button variant="outline" onClick={() => nav.navigate(`/clients/${orgId}/manage?tab=social`)}>
            <Share2 className="h-4 w-4" aria-hidden />
            Open the Social media tab
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
